import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { logout } from "../../apis/auth";
import useModal from "../../hooks/useModal";
import { selectAdminAuthenticated, setLogout } from "../../redux/userSlice";
import LogoutButton from "../LogoutButton/LogoutButton";
import ConfirmationModal from "../Modals/ConfirmationModal";

const Navbar = () => {
  const { isShowing, toggle } = useModal();
  const dispatch = useDispatch();
  const adminAuthenticated = useSelector(selectAdminAuthenticated);
  const navigate = useNavigate();

  const handleLogout = async (event) => {
    if (!event) return;
    const response = await logout();
    if (response.status === "success") {
      toast.success("Logout Successful");
      dispatch(setLogout({}));
      toggle();
      navigate("/");
    } else {
      toast.error("Logout Failed");
    }
  };

  return (
    <div className="w-full relative h-fit py-1 md:h-[80px] z-40 border-b border-[#BDBDBD]">
      <div className="flex-wrap m-auto w-full h-full flex justify-center vsm:justify-between items-center pl-3 md:pl-6">
        <Link to="/" className="">
          <img
            src="/logo.png"
            alt="logo"
            className="h-[45px] md:h-[60px] cursor-pointer z-40"
          />
        </Link>
        {adminAuthenticated && (
          <div className="px-7 flex items-center justify-center">
            <LogoutButton adminLogout styled={false} />
          </div>
        )}
      </div>

      <ConfirmationModal
        title={"Are you sure you want to logout?"}
        isOpen={isShowing}
        onClose={toggle}
        onConfirm={handleLogout}
      ></ConfirmationModal>
    </div>
  );
};

export default Navbar;
